export default "__VITE_ASSET__2eb56445__"